var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconFloors(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 18.125V11.5625C20 10.5286 19.1589 9.6875 18.125 9.6875H17.0625V10.9375H18.125C18.4696 10.9375 18.75 11.2179 18.75 11.5625V14.9062H17.0938V14.2812H15.8438V16.7812H17.0938V16.1562H18.75V18.125C18.75 18.4696 18.4696 18.75 18.125 18.75H13.0625V16.1562H13.6875V14.9062H11.1875V16.1562H11.8125V18.75H10.0938V20H18.125C19.1589 20 20 19.1589 20 18.125ZM13.0625 12.75H11.8125V5.875C11.8125 5.5304 11.5321 5.25 11.1875 5.25H10.1562V4H11.1875C12.2214 4 13.0625 4.84106 13.0625 5.875V9.6875H14.8438V10.9375H13.0625V12.75ZM8.40625 12.0938H5.25V18.125C5.25 18.4696 5.5304 18.75 5.875 18.75H6.96875V20H5.875C4.84106 20 4 19.1589 4 18.125V5.875C4 4.84106 4.84106 4 5.875 4H7V5.25H5.875C5.5304 5.25 5.25 5.5304 5.25 5.875V10.8438H8.40625V10.25H9.65625V12.75H8.40625V12.0938Z",
    fill: "#99C540"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFloors);
export default __webpack_public_path__ + "static/media/icon_floors.eb1065c7e0558e966b20bc83071788b8.svg";
export { ForwardRef as ReactComponent };